import React from 'react'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import BatchForm from './parts/batch_form'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import HelpOverlay from '../utils/helpOverlay'
import ListView from 'bstrap-react-mobx-admin/new_src/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import TextField from 'react-mobx-admin/components/common/field/text'
import moment from 'moment'
import orderBy from 'lodash/orderBy'
import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const CItemsTitle = observer(({ store, helper }) => {
  return (
    <React.Fragment>
      {store.title}
      <HelpOverlay helpContent={helper} />
    </React.Fragment>
  )
})

const CItemsListView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.CONTRACTITEMS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const isFilm = store.router.params.entname === linkConst.LINK_FILM

  const ItemDetail = (row) => {
    return (
      <a className='item-link-width' title={store.__('Click to open detail')} href='javascript:void(0)' onClick={() => {
        store.goTo('contractitem_detail', {
          entname: store.router.params.entname,
          eid: store.router.params.id,
          id: row.id
        })
      }}>
        {row.title}
      </a>
    )
  }

  const ContractDetail = (row) => {
    const found = store.options.has('contracts') && store.options.get('contracts').find(i => i.id === row.contract_id)
    const text = found ? found.name : 'not found'
    return store.hasRight(defaultConst.ENTNAMES.FILMS)
      ? (
        <a className='item-link-width' title={store.__('Click to open Contract')} href='javascript:void(0)' onClick={() => {
          store.goTo('entity_detail', { entityname: 'contracts', id: row.contract_id })
        }}>
          <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
        </a>
      )
      : text
  }

  const FilmDetail = (row) => {
    const found = store.options.get('films').find(i => i.id === row.film_id)
    const text = found ? found.title : 'not found'
    return store.hasRight(defaultConst.ENTNAMES.FILMS)
      ? (
        <a className='item-link-width' title={store.__('Click to open Film')} href='javascript:void(0)' onClick={() => {
          store.goTo('entity_detail', { entityname: 'films', id: row.film_id })
        }}>
          <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
        </a>
      )
      : text
  }

  function _formatDate (val, valFrom, valTo) {
    const value = moment(val).isValid() && moment(val)
    const validFrom = valFrom && moment(valFrom).isValid() && moment(valFrom)
    const validTo = valTo && moment(valTo).isValid() && moment(valTo)
    const addClass = valTo
      ? (moment().isSameOrAfter(validFrom, 'day') && moment().isSameOrBefore(validTo, 'day')
        ? 'text-success'
        : (moment().isBefore(validTo, 'day') ? 'text-info' : 'text-danger'))
      : ''
    return <div className={'date ' + addClass}>{value ? moment(value).format('YYYY-MM-DD') : ''}</div>
  }

  const rightsField = (row) => {
    const orderedRights = orderBy(
      row.rights,
      ['right_type', 'start_license_period', 'end_license_period'],
      ['asc', 'desc', 'desc']
    )
    const rows = orderedRights.map((i, idx) => {
      return (
        <tr key={idx} className={'item-rights-normal'}>
          <td>{_formatDate(
            i.start_license_period,
            i.start_license_period,
            (i.canceled_date || i.end_license_period)
          )}</td>
          <td>{_formatDate(
            i.end_license_period,
            i.start_license_period,
            (i.canceled_date || i.end_license_period)
          )}</td>
          <td>
            <div className='regions' title={i.regions}>{i.regions}</div>
          </td>
          <td className='status nowrap'>
            <OptionsField
              val={i.status}
              options={store.options.get('ContractItemStatus')}
              labelattr='text'
              valueattr='value' />
          </td>
          <td className='platform nowrap'>
            <OptionsField
              val={i.platform}
              options={store.options.get('Platforms')}
              labelattr='text'
              valueattr='value' />
          </td>
          <td>{_formatDate(i.canceled_date, i.canceled_date, i.canceled_date)}</td>
          <td className='right-type nowrap'>
            <OptionsField
              val={i.right_type}
              options={store.options.get('RightsTypes')}
              labelattr='text'
              valueattr='value' />
          </td>
          <td><BoolField attr={'fl'} val={i.rights_exclusive_flg} /></td>
          <td className='pricing-tier'>{i.pricing_tier}</td>
          <td>{i.minimum_fee_sd && parseFloat(i.minimum_fee_sd).toFixed(2)}</td>
          <td>{i.minimum_fee_hd && parseFloat(i.minimum_fee_hd).toFixed(2)}</td>
        </tr>
      )
    })

    return orderedRights.length > 0
      ? (
        <table className='righttable'>
          <thead>
            <tr className={'item-rights-header'}>
              <th className='nowrap'>{store.__('License starts')}</th>
              <th className='nowrap'>{store.__('License ends')}</th>
              <th>{store.__('Regions')}</th>
              <th>{store.__('Status')}</th>
              <th>{store.__('Platform')}</th>
              <th>{store.__('Canceled')}</th>
              <th className='nowrap'>{store.__('Right type')}</th>
              <th>{store.__('Exclusive')}</th>
              <th className='nowrap'>{store.__('Pricing tier')}</th>
              <th className='nowrap'>{store.__('Minimum fee SD')}</th>
              <th className='nowrap'>{store.__('Minimum fee HD')}</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      )
      : null
  }

  function fieldCreator (attr, row) {
    const val = row[attr]
    switch (attr) {
    case 'delivered_date': return _formatDate(val)
    case 'contract_type': return (<OptionsField
      attr={attr}
      val={(
        store.options.get('contracts').find(i => i.id === row.contract_id) &&
          store.options.get('contracts').find(i => i.id === row.contract_id).contract_type
      ) || null}
      options={store.options.get('ContractTypes')}
      labelattr='text' valueattr='value' />)
    case 'rights': return rightsField(row)
    case 'platform_specific_licence_period_flg': return <BoolField attr={attr} val={val} />
    case 'edit': return (
      <Button bsStyle='info' bsSize='sm' onClick={() => {
        const entname = store.router.params.entname
        const eid = store.router.params.id
        store.goTo('contractitem_detail', { entname, eid, id: row.id })
      }}>
        <span className='glyphicon glyphicon-edit' />&nbsp; {store.__('Edit')}
      </Button>
    )
    case 'title': return ItemDetail(row)
    case 'contract_id': return ContractDetail(row)
    case 'film_id': return FilmDetail(row)
    case 'minimal_guarantee': return <TextField val={row[attr]} toFixed={2} />
    case 'cost_sum': return <TextField val={row[attr]} toFixed={2} />
    default: return val
    }
  }

  const batchActions = () => (
    <DropdownButton className={defaultConst.ACTION_BUTTON_CLASS1} title={store.__(defaultConst.TITLE_ACTIONS)} pullRight id='listactions-dropdown'>
      <MenuItem eventKey={0} onClick={() => store.cv.batchAction('set')}>
        {store.__('Batch set basic attrs')}
      </MenuItem>
      <MenuItem eventKey={1} onClick={() => store.cv.batchAction('addex')}>
        {store.__('Batch add costs')}
      </MenuItem>
      <MenuItem eventKey={2} onClick={() => store.cv.batchAction('addRights')}>
        {store.__('Batch add rights')}
      </MenuItem>
      <MenuItem divider />
      <MenuItem key={'delete'} eventKey={'delete'} onClick={() => store.cv.batchAction('del')}>
        <span className='glyphicon glyphicon-remove' />&nbsp; {store.__(defaultConst.TITLE_DELETE)}
      </MenuItem>
    </DropdownButton>
  )

  const typeClassMapping = {
    sale: 'contractitem_type_sale',
    purchase: 'contractitem_type_purchase',
    resale: 'contractitem_type_resale'
  }
  const CustomTR = ({ children, selected, row }) => {
    const contract = store.options.get('contracts').find(i => i.id === row.contract_id)
    const type = contract ? contract.contract_type : null
    return <tr className={typeClassMapping[type]}>{children}</tr>
  }

  return (
    <div>
      <Helmet title={isFilm ? linkConst.LINK_FILM_ITEMS_TITLE : linkConst.LINK_CONTRACT_ITEMS_TITLE} />
      <ListView
        store={store.cv}
        helper={store.helpFor(linkConst.LINK_CONTRACT_ITEMS)}
        fieldCreator={fieldCreator}
        onAddClicked={() => store.cv.addClicked()}
        batchActions={batchActions}
        options={{
          title: () => (
            <div>
              <CItemsTitle store={store.cv} helper={store.helpFor(linkConst.LINK_CONTRACT_ITEMS)} />
              <div style={{ paddingTop: '0.5em' }}>
                <HelpOverlay helpContent={`Show ${isFilm ? 'films' : 'contracts'} list entity`}><Button bsStyle='primary buttons-vertical-align' style={{ marginRight: '1.1em' }}
                  onClick={() => store.goTo('entity_list', { entityname: isFilm ? linkConst.LINK_FILMS : linkConst.LINK_CONTRACTS })}>
                  <span className='glyphicon glyphicon-share-alt' />&nbsp;
                  {isFilm ? linkConst.LINK_FILMS_TITLE : linkConst.LINK_CONTRACTS_TITLE}
                </Button></HelpOverlay>
                <HelpOverlay helpContent={`Show ${isFilm ? 'film' : 'contract'} associated with these titles/contractitems`}><Button bsStyle='info buttons-vertical-align'
                  onClick={() => store.goTo('entity_detail', { entityname: isFilm ? linkConst.LINK_FILMS : linkConst.LINK_CONTRACTS, id: store.router.params.id })}>
                  <span className='glyphicon glyphicon-share-alt' />&nbsp;
                  {isFilm ? linkConst.LINK_FILM_DETAIL_TITLE : linkConst.LINK_CONTRACT_DETAIL_TITLE}
                </Button></HelpOverlay>
              </div>
            </div>
          ),
          addText: () => ([
            (<em key={0} className='glyphicon glyphicon-plus-sign' />),
            (<span key={1}>&nbsp;{defaultConst.TITLE_CREATE}</span>)
          ]),
          emptyComponent: () => 'Nothing found :('
        }}
        TRComponent={CustomTR} />
      <BatchForm store={store} />
    </div>
  )
}
export default inject('store')(observer(CItemsListView))
